<div appTheme>
    <div class="main-container scrolling fixed-width-container">
        <div id="about-container" class="container col-sm-12">
            <h1>About SMRTScape<sup>&trade;</sup> and SMRT Logic<sup>&trade;</sup></h1>
            <hr>
            <span class="name">Wireless Irrigation Control</span>
            <p>SMRTScape.com is the cloud-based control you've been waiting for. It provides a convenient way to access and control irrigation and lighting systems
                from any web or mobile device. The SMRT Logic internet gateway provides the hassle-free connection to SMRTScape.com for the landscape features you
                want to control.</p>
            <div class="about-smrtscape-image">
                <img src="../../../assets/images/aboutSMRTScape.png">
            </div>

            <div class="row row-equal-height">
                <div class="col-xs-12 col-sm-12 col-md-6">
                    <div class="panel panel-default ">
                        <div class="panel-heading">
                            <span class="name">Homeowner Benefits</span>
                        </div>
                        <div class="panel-body">
                            <div class="row panel-item-container">
                                <div class="col-xs-6 col-sm-6 col-md-6">Turn on or off irrigation, lighting or other outdoor features using your web browser or
                                    mobile device
                                </div>
                                <div class="col-xs-6 col-sm-6 col-md-6">Upgrade new and existing irrigation controllers</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-xs-12 col-sm-12 col-md-6">
                    <div class="panel panel-default">
                        <div class="panel-heading">
                            <span class="name">Why SMRT Logic?</span>
                        </div>
                        <div class="panel-body">
                            <div class="row panel-item-container">
                                <div class="col-md-4">Manage 5 controllers, lighting and more with a single SMRT Logic</div>
                                <div class="col-md-4">Provides over 3 times the range of typical Wi-Fi devices</div>
                                <div class="col-md-4">Simple plug and play internet connection. No Wi-Fi password required</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row row-equal-height">
                <div class="col-xs-12 col-sm-12 col-md-6">
                    <div class="panel panel-default ">
                        <div class="panel-heading">
                            <span class="name">Compatible Toro Controllers</span>
                        </div>
                        <div class="panel-body">
                            <div class="row panel-item-container">
                                <div class="panel-item"><a (click)="evolution.toggle($event)">EVOLUTION® Controller equipped with Smart Connect®</a></div>
                                <div class="panel-item"><a (click)="tmc424.toggle($event)">TMC-424 Controller equipped with Irritrol® Climate Logic®</a></div>
                                <div class="panel-item"><a (click)="tmc212.toggle($event)">TMC-212 Controller equipped with Irritrol® Climate Logic®</a></div>
                                <div class="panel-item"><a (click)="cc.toggle($event)">Custom Command™ Controller equipped with Irritrol® Climate Logic®</a></div>
                                <div class="panel-item"><a (click)="evoag.toggle($event)">EVOLUTION® Ag Controller equipped with Smart Connect®</a></div>
                                <div class="panel-item"><a (click)="lxc.toggle($event)">LXC® Controller equipped with SmartR®</a></div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-xs-12 col-sm-12 col-md-6">
                    <div class="panel panel-default">
                        <div class="panel-heading">
                            <span class="name">Compatible Irritrol Controllers</span>
                        </div>
                        <div class="panel-body">
                            <div class="row panel-item-container">
                                <div class="panel-item"><a (click)="kd2.toggle($event)">KD2 Controller equipped with Climate Logic®</a></div>
                                <div class="panel-item"><a (click)="kd.toggle($event)">Kwik Dial® Controller equipped with Climate Logic®</a></div>
                                <div class="panel-item"><a (click)="rd.toggle($event)">Rain Dial®-R Controller equipped with Climate Logic®</a></div>
                                <div class="panel-item"><a (click)="tc.toggle($event)">Total Control®-R Controller equipped with Climate Logic®</a></div>
                                <div class="panel-item"><a (click)="mce.toggle($event)">MC-E "Blue" Controller equipped with Climate Logic®</a></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-sm-6">
                <span class="name">
                    For more information, visit
                    <a href="http://www.toro.com" target="_blank"> Toro.com</a>
                </span>
                </div>
                <div class="col-sm-6">
                <span class="name">
                    For more information, visit
                    <a href="https://www.irritrol.com/" target="_blank"> Irritol.com</a>
                </span>
                </div>
            </div>
        </div>
    </div>
</div>

<p-overlayPanel #evolution [dismissable]="true" [showCloseIcon]="true" appendTo="body">
    <img src="../../../assets/images/about-evo.png"/>
</p-overlayPanel>
<p-overlayPanel #tmc424 [dismissable]="true" [showCloseIcon]="true" appendTo="body">
    <img src="../../../assets/images/abt-tmc-424.png"/>
</p-overlayPanel>
<p-overlayPanel #tmc212 [dismissable]="true" [showCloseIcon]="true" appendTo="body">
    <img src="../../../assets/images/abt-tmc-212.png"/>
</p-overlayPanel>
<p-overlayPanel #cc [dismissable]="true" [showCloseIcon]="true" appendTo="body">
    <img src="../../../assets/images/abt-cc.png"/>
</p-overlayPanel>
<p-overlayPanel #evoag [dismissable]="true" [showCloseIcon]="true" appendTo="body">
    <img src="../../../assets/images/abt-evo-ag.png"/>
</p-overlayPanel>
<p-overlayPanel #kd2 [dismissable]="true" [showCloseIcon]="true" appendTo="body">
    <img src="../../../assets/images/abt-kd2.png"/>
</p-overlayPanel>
<p-overlayPanel #kd [dismissable]="true" [showCloseIcon]="true" appendTo="body">
    <img src="../../../assets/images/abt-kd.png"/>
</p-overlayPanel>
<p-overlayPanel #rd [dismissable]="true" [showCloseIcon]="true" appendTo="body">
    <img src="../../../assets/images/abt-rd.png"/>
</p-overlayPanel>
<p-overlayPanel #tc [dismissable]="true" [showCloseIcon]="true" appendTo="body">
    <img src="../../../assets/images/abt-tc.png"/>
</p-overlayPanel>
<p-overlayPanel #mce [dismissable]="true" [showCloseIcon]="true" appendTo="body">
    <img src="../../../assets/images/abt-mce.png"/>
</p-overlayPanel>
<p-overlayPanel #lxc [dismissable]="true" [showCloseIcon]="true" appendTo="body">
    <img src="../../../assets/images/abt-lxc.png"/>
</p-overlayPanel>
<!-- //TODO LXC  -->
